<div class="patient-block-body">
  <div
    class="modalHeaderBlack height45"
    data-automation-attribute="div-modal-header"
  >
    <mat-grid-list cols="15" class="width100 mg-0" rowHeight="50px">
      <div *ngIf="isMergePatient">
        <mat-grid-tile [colspan]="4" [rowspan]="1" class="header-grid-tile">
          <h6 class="modal-title">
            &nbsp;{{ "payerInfo.selectsecondarypatient" | translate }} &nbsp;
          </h6>
        </mat-grid-tile>
      </div>
      <div *ngIf="!isMergePatient" style="justify-content:flex-start">
        <mat-grid-tile [colspan]="2" [rowspan]="1" class="header-grid-tile">
          <h6 class="modal-title">
            &nbsp;     &nbsp; {{ "RegistrationPage.blockPatient" | translate }}  &nbsp;
          </h6>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="1" class="header-grid-tile">
        </mat-grid-tile>

        <!-- <mat-grid-tile [colspan]="2" [rowspan]="1" class="header-grid-tile">
          <mat-radio-group
            [(ngModel)]="filterType"
            name="patientType"
            data-automation-attribute="radiogrp-patient-type"
          >
            <mat-radio-button
              [value]="'patient'"
              data-automation-attribute="radio-new"
              >{{
                "EncounterListPage.patientdetails" | translate
              }}</mat-radio-button
            >
          </mat-radio-group>
        </mat-grid-tile> -->
      </div>

      <mat-grid-tile [colspan]="10" [rowspan]="1" class="header-grid-tile">
        <div class="master-search" >
          <mat-icon matTooltip="{{ 'SearchHeader.placeholder' | translate }}" class="search-icon"
            >search</mat-icon
          >
          <input
            type="text"
            (focusout)="isVisible = false"
            [(ngModel)]="searchValue"
            (keyup.enter)="getKeySearch(searchValue)"
            [placeholder]="'payerInfo.searchPatient' | translate"
            pattern="[a-zA-Z0-9]+"
          />
          <div
          class="master-dropdown"
          [matMenuTriggerFor]="masterSearch"
          *ngIf="searchList && searchList.length > 0"
          (blur)="isVisible = false"
        >
          <mat-icon
            (click)="isVisible = true"
            style="line-height: 36px;"
            matTooltip="{{ 'payerInfo.expand' | translate }}"
            *ngIf="!isVisible && !isTyped"
          >
            arrow_drop_down</mat-icon
          >
          <mat-icon
            (click)="isVisible = false"
            style="padding-top: 20%;"
            matTooltip="{{ 'payerInfo.collapse' | translate }}"
            *ngIf="isVisible && !isTyped"
          >
            arrow_drop_up</mat-icon
          >
        </div>
        </div>
       

        <mat-menu
          class="menu-master"
          yPosition="below"
          [overlapTrigger]="false"
          #masterSearch="matMenu"
        >
          <div>
            <form
              #searchForm="ngForm"
              class="master-search-form"
              (ngSubmit)="setSearch(searchForm.value)"
              data-automation-attribute="form-search"
            >
              <div
                (click)="$event.stopPropagation()"
                *ngFor="let search of searchList; let p_index = index"
                class="search-content-row"
              >
                <div
                  *ngFor="let control of search.controls; let c_index = index"
                  class="search-col search-col-{{ control.column }}"
                >
                  <mat-radio-group
                    *ngIf="control.type == 'radio'"
                    [(ngModel)]="this[control.name]"
                    name="{{ control.name }}"
                  >
                    <mat-radio-button
                      *ngFor="let radio of control.radios; let r_index = index"
                      value="{{ radio.value }}"
                      (click)="radioOnClick(radio)"
                      >{{ radio.text }}</mat-radio-button
                    >
                  </mat-radio-group>

                  <mat-form-field
                    *ngIf="control.type == 'date'"
                    appearance="outline"
                  >
                    <mat-label>{{ control.placeholder }}</mat-label>

                    <input
                      matInput
                      [matDatepicker]="picker"
                      [min]="minDate"
                      placeholder="{{ control.placeholder }}"
                      [(ngModel)]="this[control.name]"
                      value="{{ control.value }}"
                      name="{{ control.name }}"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="control.type == 'text'"
                    appearance="outline"
                  >
                    <mat-label>{{ control.placeholder }}</mat-label>
                    <input
                      matInput
                      placeholder="{{ control.placeholder }}"
                      [(ngModel)]="this[control.name]"
                      name="{{ control.name }}"
                      value="{{ control.value }}"
                      pattern="[a-zA-Z0-9]+"
                    />
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="control.type == 'number'"
                    appearance="outline"
                  >
                    <mat-label>{{ control.placeholder }}</mat-label>
                    <input
                      type="number"
                      matInput
                      placeholder="{{ control.placeholder }}"
                      [(ngModel)]="this[control.name]"
                      name="{{ control.name }}"
                      value="{{ control.value }}"
                      pattern="[a-zA-Z0-9]+"
                    />
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="control.type == 'select'"
                    appearance="outline"
                  >
                    <mat-label>{{ control.placeholder }}</mat-label>

                    <mat-select
                      id="{{ control.name }}"
                      placeholder="{{ control.placeholder }}"
                      [(ngModel)]="this[control.name]"
                      name="{{ control.name }}"
                      (selectionChange)="
                        selectOnChange(control.name, $event.value)
                      "
                      value="{{ control.value }}"
                      (focus)="selectOnClick(control, p_index, c_index)"
                    >
                      <div *ngIf="[control.name] == 'unit'">
                        <mat-option
                          *ngFor="let option of control.options"
                          [value]="option.id"
                        >
                          {{ option.desc }}
                        </mat-option>
                      </div>

                      <div *ngIf="[control.name] != 'unit'">
                        <mat-option
                          *ngFor="let option of control.options"
                          [value]="option"
                        >
                          {{ option.desc }}
                        </mat-option>
                      </div>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="search-content-row">
                <div class="search-col search-col-12 right">
                  <button
                    type="submit"
                    class="btn-master-search"
                    data-automation-attribute="btn-search"
                    mat-button
                    matTooltip="{{ 'SearchHeader.placeholder' | translate }}"
                  >
                    <mat-icon
                      >search</mat-icon
                    >
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    class="btn-master-cancel"
                    mat-button
                    (click)="clearSearch()"
                    matTooltip="{{ 'AppointmentPage.refresh' | translate }}"
                  >
                    <mat-icon
                      >refresh</mat-icon
                    >
                  </button>
                </div>
              </div>
            </form>
          </div>
        </mat-menu>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <span
          aria-label="Close"
          (click)="onCloseClick()"
          style="float: right"
          data-automation-attribute="button-close-dialog"
          data-automation-attribute="span-dialog-close"
        >
          <mat-icon matTooltip="{{'AddInternalNotes.close' | translate}}">clear</mat-icon>
        </span>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <!---------------------------------------------------------------------------------------------------------------->

  <div
    style="padding-left: 5px; padding-bottom: 5px"
    class="divRecordsNo"
    data-automation-attribute="divRecordsNo"
  >
    <table
      class="divTableRecords"
      data-automation-attribute="tblRecordsNo"
      *ngIf="showdSelected && showPatient"
    >
      <tr>
        <td class="tdRecords">
          <b>{{ "payerInfo.selectedPatient" | translate }}</b>
        </td>
      </tr>
    </table>
  </div>

  <div class="divSearchResult" data-automation-attribute="tblSearchresult">
    <div
      style="padding-left: 5px; padding-right: 5px; padding-bottom: 10px"
      class="example-container mat-elevation-z8"
      data-automation-attribute="divSearchResult"
    >
      <mat-table
        class="height200"
        *ngIf="showdSelected && showPatient"
        data-automation-attribute="tblSearchResultTable"
      >
        <ng-container matColumnDef="PatientDetails">
          <mat-header-cell *matHeaderCellDef class="headerMRN">
            <img
              [src]="selectedPhoto"
              *ngIf="selectedPhoto"
              class="height30 rounded-circle"
            />
            <img
              src="assets/images/noavatar.png"
              *ngIf="!selectedPhoto"
              class="height30 rounded-circle"
            />
            &nbsp; {{ selectedMRN }} / {{ selectedName }} /
            {{ selectedGender }} / {{ selectedPatient.dateOfBirth}} {{ selectedPatient.age}}  
          </mat-header-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedBannerColumns"
          class="tableHeader"
        ></mat-header-row>
      </mat-table>
    </div>
  </div>

  <div class="divfilter"></div>
  <div
    class="divRecordsNo"
    *ngIf="showborder"
    data-automation-attribute="divRecordsNo"
  >
    <table class="divTableRecords" data-automation-attribute="tblRecordsNo">
      <tr>
        <td class="tdRecords">
          <b
            >{{ "payerInfo.recordsFound" | translate }} ( {{ searchCount }} )
          </b>
        </td>
        <!-- <td class="tdBtnClose">
          <button
            id="btnClose"
            class="mat-mini-fab btnRed"
            mat-button
            data-automation-attribute="btnCloseRecords"
            (click)="clearRecord()"
              matTooltip="{{ 'AddInternalNotes.close' | translate }}"
          >
            <mat-icon>close</mat-icon>
          </button>
        </td> -->
      </tr>
    </table>
  </div>

  <div
    class="divSearchResult"
    *ngIf="showborder"
    data-automation-attribute="tblSearchresult"
  >
    <div
      style="padding-bottom: 10px"
      class="example-container mat-elevation-z8"
      *ngIf="showborder"
      data-automation-attribute="divSearchResult"
    >
      <mat-table
        #table
        [dataSource]="dataSource"
        class="height200"
        *ngIf="showd && showPatient"
        data-automation-attribute="tblSearchResultTable"
      >
        <ng-container matColumnDef="photo">
          <mat-header-cell *matHeaderCellDef class="headerPhoto">
            {{ "RegistrationPage.photo" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="headerPhoto">
            <img
              src="{{
                element.image ? element.image : 'assets/images/user-black.png'
              }}"
              class="height30 rounded-circle"
              alt="user"
            />
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="MRN">
          <mat-header-cell *matHeaderCellDef class="headerMRN">
            {{ "RegistrationPage.mrn" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="headerMRN">
            <span [matTooltip]="element.mrn">
            {{ element.mrn?.length > 12 ? element.mrn.slice(0, 12) + '..' : element.mrn }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="idtype">
          <mat-header-cell *matHeaderCellDef class="headerNRIC"
            >{{ "RegistrationPage.primaryID" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="headerNRIC">
            {{ element.identifierType }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="idnumber">
          <mat-header-cell *matHeaderCellDef class="headerID">
            {{ "RegistrationPage.primaryDocNo" | translate }}</mat-header-cell
          >
          <mat-cell *matCellDef="let element" class="headerID">
            {{ element.idNo }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef class="headerName">
            {{ "RegistrationPage.name" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="headerName">
            {{ element.patientNameLangBase || element.fullName }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="gender">
          <mat-header-cell *matHeaderCellDef class="headerGender">
            {{ "RegistrationPage.gender" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="headerGender">
            {{ element.gender }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="contact">
          <mat-header-cell *matHeaderCellDef class="headerContact">
            {{ "RegistrationPage.phone" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="headerContact">
            {{ element.mobileNumber }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dob">
          <mat-header-cell *matHeaderCellDef class="headerDate">
            {{ "RegistrationPage.dobColumn" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" id="abc" class="headerDate">
            {{ element.dateOfBirth}}
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="tableHeader"
        ></mat-header-row>
        <mat-row
          (click)="rowClicked(row)"
          *matRowDef="let row; columns: displayedColumns"
          class="tableRow"
          data-automation-attribute="rowSearchResult"
        ></mat-row>
      </mat-table>
    </div>
  </div>
  <div *ngIf="isMergePatient  && !this.isShow" class="height"></div>

  <div *ngIf="!isMergePatient">
    <mat-form-field
      class="fieldBox"
      style="padding-bottom: 20px; padding-left: 15px"
      appearance="outline"
    >
      <mat-label>{{ "payerInfo.reason" | translate }}</mat-label>
      <mat-select [required]="true" [(ngModel)]="selectedReason" name="reason">
        <mat-option>
          <ngx-mat-select-search
            [formControl]="reasonSearch"
            [placeholderLabel]="'payerInfo.reason' | translate"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option>{{
          "RegistrationPage.none" | translate
        }}</mat-option>
        <mat-option *ngFor="let reasons of reasonSample" [value]="reasons.code">
          {{ reasons.desc }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p>
      <mat-form-field
        style="padding-bottom: 20px; padding-left: 15px;"
        class="fieldBox"
        appearance="outline"
      >
        <mat-label>{{ "EncounterListPage.remarks" | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'EncounterListPage.remarks' | translate"
          [(ngModel)]="selectedRemarks"
          name="remarks"
          maxlength="250"
        />
      </mat-form-field>
    </p>

    <div>
      <td
        style="
          float: right;
          padding-right: 5px;
          padding-top: 5px;
          padding-bottom: 5px;
        "
      >
        <button mat-mini-fab class="btnRed" color="primary"   matTooltip="{{ 'payerInfo.returnwithoutSaving' | translate }}"
        (click)="returnToScreen()">
          <mat-icon>undo</mat-icon>
        </button>
      </td>
    </div>

    <div>
      <td
        style="
          float: right;
          padding-right: 5px;
          padding-top: 5px;
          padding-bottom: 5px;
        "
      >
        <button mat-mini-fab class="btnCyan" color="primary" matTooltip="{{ 'payerInfo.save' | translate }}"
        (click)="onSaveBlock(selectedRemarks, selectedReason)">
          <mat-icon >sim_card</mat-icon>
        </button>
      </td>
    </div>
  </div>
</div>
